$.namespace(
  'MemePlayerBase',
  $.Class(function (klass) {
    this.roomId = '';
    this.main = null;
    this.options = null;

    _.assign(this, {
      _onInit: function () {},
      _onPlay: function () {},
      _onReplay: function () {},
      _onReload: function () {},
      _onDestroy: function () {},
      _onSetVolume: function () {},
    });

    this.init = function (main, options) {
      this.main = main;
      this.$dom = options.$dom;
      this.$player = options.$player;
      this.$playerSetting = options.$playerSetting;
      this.$videoWrap = options.$player.find('.ui-player-video');
      this.$loading = options.$player.find('.ui-player-loading');
      this.options = options;

      this.roomId = options.roomId;
      this.url = options.url;

      this.log('init:', options);

      this.controller = new MemePlayerController(this, options);
      this.track = new MemePlayerTrack(this, options);

      this._registerEvent();
      this._onInit();

      if (this.roomId) {
        this.play(this.roomId, this.url);
      }
    };

    this.showLoading = function () {
      var that = this;
      this.loadingTimer = setTimeout(function () {
        that.$loading.show();
      }, 1000);
    };
    this.hideLoading = function () {
      clearTimeout(this.loadingTimer);
      this.$loading.hide();
    };

    this._registerEvent = function () {
      this.$dom.undelegate('.player');
      this.$dom.delegate('.j_btn_play', 'click.player', this.reload.bind(this));
      this.$dom.delegate(
        '.j_btn_reload',
        'click.player',
        this.reload.bind(this),
      );
    };

    this.play = function (roomId, url) {
      this.roomId = roomId;
      this._onPlay(roomId, url);
    };

    this.reload = function () {
      this.log('base reload');
      this.play(this.roomId);
      this._onReload();
    };

    this.destroy = function () {
      this._onDestroy();
      this.log('base destroy');
      this.hideLoading();
      var that = this;
      // 有一个全局日志事件冒泡，删除后就无效，setTimeout兼容写法
      setTimeout(function () {
        that.$dom.find('.ui-player-action').remove(); // 自动播放按钮移除
      }, 20);
      this.$player.remove();
      this.$playerSetting.remove();
    };

    this._setVolume = function (val) {
      this._onSetVolume(val);
    };

    this.getSnapshot = function () {
      return '';
    };

    this.playerType = '';
    this.log = function () {
      var args = [];
      _.forEach(arguments, function (value) {
        args.push(value);
      });

      debug.apply(
        null,
        ['【' + this.roomId + '-' + this.playerType + '-player】'].concat(args),
      );
    };
  }),
);
